import { dataMember, required } from 'santee-dcts';

export const drawerBehaviorKey = 'WorkspaceLevel_DrawerBehavior';

export class WorkspaceDrawerBehavior {
    @dataMember()
    @required()
    public manualCollapsed: boolean;
}